import React from 'react';
import { motion } from 'framer-motion';

interface Testimonial {
  id: number;
  quote: string;
  name: string;
  position: string;
  company: string;
}

const Testimonials: React.FC = () => {
  // Testimonials based on the case study
  const testimonials: Testimonial[] = [
    {
      id: 1,
      quote: "The AI assistant Zaira built for us completely transformed our content creation process. Breaking down 3-4 hour podcasts into Twitter posts used to be incredibly time-consuming, but now it's automated and precise.",
      name: "Blancc Media",
      position: "CEO",
      company: "Personal Branding Agency"
    },
    {
      id: 2,
      quote: "The competitor analysis automation has given us incredible insights that helped us outperform other influencers in our niche. We're seeing significantly better engagement since implementing these tools.",
      name: "Blancc Media",
      position: "Marketing Director",
      company: "Personal Branding Agency"
    },
    {
      id: 3,
      quote: "Zaira's automations have saved us at least 17-20 hours per week. The standardized processes have allowed us to scale without having to rethink our content strategy every time.",
      name: "Blancc Media",
      position: "Operations Manager",
      company: "Personal Branding Agency"
    }
  ];

  return (
    <div className="gradient-bg py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-6 text-center"
        >
          <div className="inline-block px-3 py-1 rounded-full bg-accent/10 border border-accent/20 text-accent mb-6">
            <span className="text-sm font-medium">Happy Customers</span>
          </div>
        </motion.div>
        
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-5xl font-bold text-center mb-16"
        >
          We've made countless<br />clients happy.
        </motion.h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-primary/30 backdrop-blur-sm rounded-xl p-8"
            >
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-accent" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              
              <p className="text-gray-300 mb-6">"{testimonial.quote}"</p>
              
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-gray-700 mr-3"></div>
                <div>
                  <p className="font-medium">{testimonial.name}</p>
                  <p className="text-sm text-gray-400">{testimonial.position}, {testimonial.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
